import React from 'react';
import Panel from "../../structure/Panel";
import ContactSupport from "../../support/ContactSupport";
import { FormValues } from "../../common/FormValues";
import DownloadClaim from "../../support/DownloadClaim";
import { useFormikContext } from "formik";

interface FinishedProps {
    headerText: string,
    submissionText: string,
    actionsRight?: React.ReactNode
}

const Finished = (props: FinishedProps) => {
    const { values } = useFormikContext<FormValues>();
    const claimNumbers = values.claimNumbers?.filter(claimNumber => !!claimNumber);
    return (
        <Panel headerText={props.headerText}
               panelContent={
                   <div>
                       {claimNumbers?.length > 0 && <h4>Your claim number(s) are: {claimNumbers.join(', ')}.</h4>}
                       <h4>{props.submissionText}</h4>
                       {}
                       <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-start', marginTop: '16px' }}>
                           <DownloadClaim/>
                           {props.actionsRight && (
                               <div>{props.actionsRight}</div>
                           )}
                       </div>
                       <ContactSupport/>
                   </div>}
        >
        </Panel>
    )
};
export default Finished;